import { request } from './ChartConfigService';

// Tableros guardados del modo Dashboard (whisperbi-agent-management-strands,
// dashboards_api.py, sobre AgentsAdminApi con Cognito). En D4 son privados:
// cada usuario ve solo los suyos.
const enc = encodeURIComponent;

const DashboardsService = {
  list() {
    return request('/dashboards', { method: 'GET' });
  },
  save({ workspaceId, dashboard, sourceQuestion }) {
    return request('/dashboards', {
      method: 'POST',
      body: JSON.stringify({ workspace_id: workspaceId, dashboard, source_question: sourceQuestion })
    });
  },
  get(dashboardId) {
    return request(`/dashboards/${enc(dashboardId)}`, { method: 'GET' });
  },
  update(dashboardId, changes) {
    return request(`/dashboards/${enc(dashboardId)}`, { method: 'PUT', body: JSON.stringify(changes) });
  },
  remove(dashboardId) {
    return request(`/dashboards/${enc(dashboardId)}`, { method: 'DELETE' });
  },
  refresh(dashboardId) {
    return request(`/dashboards/${enc(dashboardId)}/refresh`, { method: 'POST' });
  },
  getRun(dashboardId, runId) {
    return request(`/dashboards/${enc(dashboardId)}/runs/${enc(runId)}`, { method: 'GET' });
  }
};

/** Tiles de la definición con el último resultado guardado de cada uno. */
export const withResults = (dashboard, results = {}) => ({
  ...dashboard,
  tiles: (dashboard.tiles || []).map((tile) => ({
    ...tile,
    result: results[tile.id] || { ok: false, error_kind: 'pending', message: 'Aún sin datos: pulsa Refrescar.' }
  }))
});

export default DashboardsService;
